import { axiosClient } from "./axiosClient"

export const ORDER_RETURN_PATH = '/api/v1/order-return'

export const addOrderReturn = (body) => {
    return axiosClient.post(ORDER_RETURN_PATH, body)
}

export const deleteOrderReturn = (id) => {
    return axiosClient.delete(`${ORDER_RETURN_PATH}/${id}`)
}

export const getAllOrderReturns = ({ orderId = '' }) => {
    return axiosClient.get(`${ORDER_RETURN_PATH}?orderId=${orderId}`)
}

export const chargeOrderReturn = (id) => {
    return axiosClient.put(`${ORDER_RETURN_PATH}/charge/${id}`)
}

export const dechargeOrderReturn = (id) => {
    return axiosClient.put(`${ORDER_RETURN_PATH}/decharge/${id}`)
}

export const getPageOrderReturn = ({ lastId = '', id = '', customerId = '', invoiceNumber = '' }) => {
    return axiosClient.get(`${ORDER_RETURN_PATH}/page?lastId=${lastId}&id=${id}&customerId=${customerId}&invoiceNumber=${invoiceNumber}`)
}